import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Resends the KYC onboarding link to the entity's email.
 * GET api/Onboarding/resend-kyc-link/{entityPrimaryId}
 *
 * @param {number} entityPrimaryId
 */
export const resendKycLinkAction = async (entityPrimaryId) => {
  try {
    const response = await apiClient.get(
      `${ATP_API_URL.RESEND_KYC_LINK}/${entityPrimaryId}`,
    );

    if (response?.status === 200) {
      return {
        success: true,
        message: response.data?.message || "KYC link resent successfully",
      };
    }
    return { success: false, message: "Failed to resend KYC link" };
  } catch (error) {
    return { success: false, message: error.message };
  }
};
